import React, { ReactElement, useMemo } from "react";
import {
  Levensverzekering,
  VoorstelLevensverzekeringHoofdstuk,
} from "../../../../../.generated/rapportage/rapportagetypes";
import Table from "../../../components/Table";
import { Paragraph } from "../../../components/Paragraph";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { getLevensverzekeringColumns } from "../../Producten/levensverzekering-kolommen";

export const LevensverzekeringData = ({
  levensverzekering,
}: {
  levensverzekering: Levensverzekering;
}): ReactElement => {
  const data = new Array(levensverzekering);

  /* istanbul ignore next */
  const columns = useMemo(() => {
    return getLevensverzekeringColumns(levensverzekering);
  }, [levensverzekering]);

  return (
    <>
      {data.length > 0 && (
        <Table
          data={data}
          columns={columns}
          rotate={true}
          filterNullAnd0Columns={true}
          appendEmptyCells={true}
          className="break-avoid"
        />
      )}
    </>
  );
};

type LevensverzekeringProps = {
  hoofdstuk: VoorstelLevensverzekeringHoofdstuk;
};

export const LevensverzekeringChapter = ({
  hoofdstuk,
}: LevensverzekeringProps): ReactElement => {
  return (
    <Chapter>
      {hoofdstuk.titel && <Heading text={`${hoofdstuk.titel}`} level={3} />}

      <Paragraph paragraaf={hoofdstuk?.paragrafen?.["p305060201"]} />

      {hoofdstuk.levensverzekeringen?.map((levensverzekering, index) => {
        return (
          <LevensverzekeringData
            key={`levensverzekering-${index}`}
            levensverzekering={levensverzekering}
          />
        );
      })}
    </Chapter>
  );
};
